export default "__VITE_ASSET__Cg47Si24__"